import SchemaMarkup from "../Components/SchemaMarkup";

const MedicalClinicSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "MedicalClinic",

    "@id": "https://msayurved.com/#medicalclinic",

    "name": "Dr. Jigar Gor Ayurveda",
    "url": "https://msayurved.com/",

    "logo": {
      "@type": "ImageObject",
      "url": "https://msayurved.com/logo.svg"
    },

    "image": "https://msayurved.com/dr-jigar-gor.webp",

    "description":
      "Dr. Jigar Gor's Ayurveda Center in Bhuj, Kutch provides personalized Ayurvedic consultations and traditional Ayurvedic treatments for holistic health and wellness.",

    "telephone": "+91-9099094847",

    "email": "dr.jigargor@yahoo.com",

    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Narayan Complex",
      "addressLocality": "Madhapar",
      "addressRegion": "Gujarat",
      "postalCode": "370020",
      "addressCountry": "IN"
    },

    "medicalSpecialty": "AyurvedicMedicine",

    "sameAs": [
      "https://www.facebook.com/dr.jigargor.ayurveda",
      "https://www.instagram.com/dr.jigargor.ayurveda/",
      "https://www.youtube.com/@dr.jigargor.ayurveda"
    ]
  };

  return <SchemaMarkup data={schema} /> ;
};

export default MedicalClinicSchema;